import axios from "axios";
import { ppq } from "@teamprevent/common";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import { parse } from "date-fns";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { OhCaseDetailModel } from "../crud/ohCase";
import { parseOhCaseModel } from "../crud/ohCase/model";
import { parseTaskModel } from "../task/model";

const apiUrl = (ohCaseId: string) => `/api/ohcase/${ohCaseId}/ppqReport`;

const loadPpqReport = async (ohCaseId: string, viewReportTaskId: string): Promise<ppq.PpqReportModel> => {
    const response = await axios.get(`${apiUrl(ohCaseId)}/${viewReportTaskId}`);
    return parseModel(response.data);
};

const approve = async (ohCaseId: string, taskId: string, notes: string): Promise<OhCaseDetailModel> => {
    const response = await axios.post<ServerModelWithDateStrings<OhCaseDetailModel>>(
        `${apiUrl(ohCaseId)}/${taskId}/approve`, { notes });

    return parseOhCaseModel(response.data);
};

const reject = async (ohCaseId: string, taskId: string, notes: string): Promise<TaskModel[]> => {
    const response = await axios.post<
        ServerModelWithDateStrings<TaskModel>[]
    >(`${apiUrl(ohCaseId)}/${taskId}/reject`, { notes });

    return (response.data).map(parseTaskModel);
};

const requestChanges = async (ohCaseId: string, taskId: string, notes: string): Promise<TaskModel[]> => {
    const response = await axios.post<
        ServerModelWithDateStrings<TaskModel>[]
    >(`${apiUrl(ohCaseId)}/${taskId}/requestChanges`, { notes });

    return (response.data).map(parseTaskModel);
};

const sendToEmployeeForConsent = async (ohCaseId: string, taskId: string, notes: string): Promise<OhCaseDetailModel> => {
    const response = await axios.post<ServerModelWithDateStrings<OhCaseDetailModel>>(
        `${apiUrl(ohCaseId)}/${taskId}/sendToEmployeeForConsent`, { notes });

    return parseOhCaseModel(response.data);
};

const parseModel = (ppqReport: ServerModelWithDateStrings<ppq.PpqReportModel>): ppq.PpqReportModel => ({
    ...ppqReport,
    assessmentDate: new Date(ppqReport.assessmentDate),
    dateOfBirth: parse(ppqReport.dateOfBirth, "yyyy-MM-dd", new Date())
});

export const ppqReportApi = {
    loadPpqReport,
    approve,
    reject,
    requestChanges,
    sendToEmployeeForConsent
};
